<template>
    <naj-modal ref="executionRequestInfoModal"
               :title="local.caseFile.cards.judgement.execution.requestTitle"
               :width="700"
               :persistent="true"
               :footer="true"
               :show-footer-close-button="false"
               transition="scroll-x-transition"
               content-class="dialog-content-class"
               @onClose="closeModal">
        <div class="case-info-text">
            <v-form ref="executionRequestInfoForm">
                <template>
                    <v-row>
                        <v-col>
                            <naj-input 
                                       :type-id="formFieldType.selectbox"
                                       :items="respondents"
                                       :value.sync="formModel.respondentId"
                                       item-text="name"
                                       item-value="id"
                                       validates="required"
                                       :label="local.caseFile.cards.judgement.execution.respondent"
                                       @change="loadExecutionRequesters"></naj-input>

                        </v-col>
                        <v-col>
                            <naj-input 
                                       :type-id="formFieldType.multipleSelectBox"
                                       :label="local.caseFile.cards.judgement.execution.requester"
                                       :value.sync="formModel.selectedRequesterIds"
                                       :items="allRequesters"
                                       item-value="plaintiffCasePartyId"
                                       item-text="name"
                                       validates="required"
                                       @change="setSelectedParty"></naj-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <naj-box :title="local.caseFile.cards.judgement.execution.bankInfo">

                            <template v-for="(item, index) in formModel.requesters">
                                <div class="col m-0" :key="index">
                                    <naj-box :title="item.name" class="personal-bank-info">
                                        <v-row>
                                            <naj-input :type-id="formFieldType.selectbox"
                                                       :items="banks"
                                                       :value.sync="item.selectedBank"
                                                       item-text="bankName"
                                                       item-value="bankId"
                                                       validates="required"
                                                       :label="local.caseFile.cards.judgement.execution.bankName"
                                                       @change="bankChanged"></naj-input>
                                        </v-row>
                                        <v-row>
                                            <naj-input :type-id="formFieldType.text"
                                                       :value.sync="item.ibanNumber"
                                                       :label="local.caseFile.cards.judgement.execution.ibanNumber"
                                                       :placeholder="local.caseFile.cards.judgement.execution.ibanPlaceHolder"
                                                       validates="required|validiBAN"></naj-input>

                                        </v-row>
                                        <v-row>
                                            <span>{{local.caseFile.cards.judgement.execution.ibanNote}}</span>
                                        </v-row>
                                  </naj-box>
                                </div>
                            </template>


                        </naj-box>


                    </v-row>

                </template>
            </v-form>
        </div>

        <template slot="actions"
                  slot-scope="{ closeNajModal }">
            <div>
                <naj-button :disabled="loading"
                            class="btn-style"
                            @click="submitTanfeethRequest(closeNajModal)">
                    {{ local.caseFile.cards.judgement.execution.executeRequest }}
                </naj-button>

                <naj-button outlined
                            @click="closeModal">
                    {{ local.common.cancel }}
                </naj-button>
            </div>

        </template>
    </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
import {   casePartyRoleEnum } from '@/helpers/enum.js';

export default {
  components: {},
  props: {
    modalVisibility: {
      default: false,
      type: Boolean,
      required: false,
    },
    judgement: {
      required: true,
      type: Object,
      default: () => { }
      },
  },
  data() {
    return {
      loading: false,
      viewMode: false,
      isChecking: false,
      isPega: true,
      partyRoleId: null,
      casePartyRoleEnum,
      closeStateModal: true,
      requesters: [],
      requesterId: '',
      respondents: [],
      respondentId: '',
      banks: [],
      requesterRoleInCase: null,
      formModel: {},
        allRequesters: [],
    };
  },
  computed: {
     
  },
        watch: {
         modalVisibility(newVal) {
          if (newVal) {
              this.$refs.executionRequestInfoModal.show();
              this.loadBanks();
              this.loadRespondents();
              this.loadRequesters();
          } else {
          this.$refs.executionRequestInfoModal.close();
          }
        },
            respondentId(newVal) {
                if (newVal !== undefined)
                    this.loadExecutionRequesters();
                else
                    this.allRequesters = [];
         }
  },
  methods: {
    ...mapCasesActions([
        'getExecutiveJudgementRespondents',
        'getUserCasePartyRoleInCase',
        'getCaseRequestApplicants',
        'sendTanfeethRequest',
        'getExecutiveJudgementRequesters',
        'getAllJudgementRespondents',
        'getExecutionBanks'
    ]),
    submitTanfeethRequest() {
        this.$refs.executionRequestInfoForm.$validator.validateAll()
        .then((isValid) => {
            if (isValid) {
                this.loading = true;
                this.formModel.judgementId = this.judgement.id;
                this.formModel.caseObjectKey = this.$route.params.caseObjectKey;
                this.formModel.requesters.forEach((item) => {
                    item.requesterId = item.plaintiffCasePartyId;
                });
                this.sendTanfeethRequest(this.formModel)
                    .then(({ data }) => {
                        this.$emit('executionRequestSuccessfullySent', data);
                        this.closeModal();
                }).finally(() => (this.loading = false));
          }
        });
      },
      loadRespondents() {
          var payload = {
              judgementId: this.judgement.id,
          };
          this.getAllJudgementRespondents(payload)
              .then(({ data }) => {
                  this.respondents = data;
              });
      },
      loadExecutionRequesters() {
          this.allRequesters = [];
      if (this.formModel.respondentId !== undefined) { 
          var payload = {
              judgementId: this.judgement.id,
              casePartyId: this.formModel.respondentId,
              objectKey: this.$route.params.caseObjectKey,
          };
          this.getExecutiveJudgementRequesters(payload)
              .then(({ data }) => {
                  this.allRequesters = data;

              });
      }
      
      },
      loadRequesters() {
          this.caseObjectKey = this.$route.params.caseObjectKey;
          this.loading = true;
          const params = {
              isPega: this.isPega,
              objectKey: this.caseObjectKey,
          };
          
              this.getUserCasePartyRoleInCase(params)
              .then((res) => {
                  this.requesterRoleInCase = res.data;
                  // this.setRelatedPartyAsRequestApplicant();
              })
              .catch(err => this.toaster.error(err.message))
              .finally(() => (this.loading = false));
      },
      loadBanks() {
          const params = {

          };
          this.getExecutionBanks(params)
              .then(({ data }) => {
                  this.banks = data;
                  if (this.banks.length == 1) {
                      this.formModel.selectedBank = this.banks[0].bankId;
                  }
              });
      },
      bankChanged(value) {
          var selectedBank = this.banks.filter(x => x.bankId == value);
          this.formModel.ibanNumber = selectedBank[0].iban;
      },
      closeModal() {
        this.$emit('modalClose');
        this.$set(this, 'formModel', {});
      },
      setSelectedParty() {
          
          var selectedIds = this.formModel.selectedRequesterIds;
          this.$set(this.formModel, 'requesters', this.allRequesters.filter(function (a) {
              return selectedIds.includes(a.plaintiffCasePartyId);
          }));
          this.$set(this.formModel, 'requesterId', this.requesterRoleInCase.casePartyId);
        //  this.$set(this.formModel, 'caseObjectKey', this.formModel.case.objectKey);
      },
  },
};
</script>

<style lang="scss" scoped>

    ::v-deep .naj-box-contnet {
        padding-top: unset !important;
    }

    ::v-deep .naj-box .naj-box-contnet {
        padding-top: unset !important;
    }

    .v-input .v-label {
        font-weight: bold;
    }

    ::v-deep .v-input {
        &.v-text-field--outlined {
            .v-label {
                font-weight: bold !important;
            }
        }
    }

    ::v-deep .v-input.v-text-field--outlined .v-label {
        font-weight: bold;
    }

    ::v-deep .v-input.v-text-field--outlined .v-input__slot {
        min-height: 25px;
    }

    ::v-deep .v-icon.v-icon {
        font-size: 15px !important;
    }

    .personal-bank-info {
        font-size: 14px ;  
    }

</style>